export const Tile1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 16 16"
      shape-rendering="crispEdges"
    >
      <metadata>
        Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj
      </metadata>
      <path
        stroke="#16181e"
        d="M0 0h1M5 1h10M14 2h1M14 3h1M14 4h1M0 5h1M14 5h1M14 6h1M0 7h1M14 7h1M0 8h1M14 8h1M0 9h1M14 9h1M0 10h1M14 10h1M0 11h1M0 12h1M0 13h1M0 14h1M0 15h9M10 15h1"
      />
      <path
        stroke="#222428"
        d="M1 0h1M0 1h1M2 1h3M0 2h1M0 3h1M0 4h1M4 5h3M0 6h1M6 6h1M6 7h1M6 8h1M6 9h1M6 10h1M6 11h1M14 11h1M6 12h1M14 12h1M6 13h2M14 13h1M9 15h1M11 15h2"
      />
      <path
        stroke="#333436"
        d="M2 0h1M1 1h1M2 2h12M2 3h4M9 3h5M2 4h3M9 4h5M2 5h2M9 5h5M2 6h4M9 6h5M2 7h4M9 7h5M2 8h4M9 8h5M2 9h4M9 9h5M2 10h4M9 10h5M2 11h4M9 11h5M2 12h4M9 12h5M2 13h4M8 13h6M13 14h2M13 15h2"
      />
      <path stroke="#3d3e40" d="M3 0h1M1 2h1M1 3h1M1 4h1M10 14h3M15 15h1" />
      <path
        stroke="#4b4c4e"
        d="M4 0h2M1 5h1M1 6h1M1 7h1M1 8h1M1 9h1M15 13h1M6 14h4M15 14h1"
      />
      <path stroke="#616266" d="M6 0h2M15 11h1M15 12h1" />
      <path
        stroke="#727377"
        d="M8 0h8M15 1h1M15 2h1M15 3h1M15 4h1M15 5h1M15 6h1M15 7h1M15 8h1M15 9h1M1 10h1M15 10h1M1 11h1M1 12h1M1 13h1M1 14h5"
      />
      <path
        stroke="#668be7"
        d="M6 3h3M5 4h4M7 5h2M7 6h2M7 7h2M7 8h2M7 9h2M7 10h2M7 11h2M7 12h2"
      />
    </svg>
  );
};
